import type { ReactElement } from 'react';
import { Div } from '@fastnorth/kraken/components/layout';
import SubEventProgressTableSkeleton from './components/SubEventProgressTableSkeleton';

const EventProgressV2Skeleton = (): ReactElement => (
  <Div className="box-border w-full min-w-0 max-w-full" data-testid="event-progress-v2-skeleton">
    <SubEventProgressTableSkeleton />
  </Div>
);

export default EventProgressV2Skeleton;
